import AuthException from '../exceptions/AuthException';
import InactivityException from '../exceptions/InactivityException';
import LoginException from '../exceptions/LoginException';
import ValidationException from '../exceptions/ValidationException';
import container from '../setupAwilix';

function logError(error) {
  if (!error.logged) {
    const errorRepository = container.resolve('errorRepository');
    errorRepository.error$.next({ message: error.message, severity: 'error' });
    // eslint-disable-next-line no-param-reassign
    error.logged = true;
  }
}

function safeWrap(fn, isAsync) {
  if (isAsync) {
    return async function wrap(...args) {
      try {
        return await fn.apply(this, args);
      } catch (error) {
        if (error instanceof InactivityException) logError(error);
        if (error instanceof AuthException) {
          const authRepository = container.resolve('authRepository');
          authRepository.auth$.next(null);
          throw error;
        }

        if (error instanceof ValidationException || error instanceof LoginException) {
          throw error;
        }

        logError(error);
        throw error;
      }
    };
  }
  return function wrap(...args) {
    try {
      return fn.apply(this, args);
    } catch (error) {
      if (error instanceof InactivityException) logError(error);
      if (error instanceof AuthException) {
        const authRepository = container.resolve('authRepository');
        authRepository.auth$.next(null);
        throw error;
      }

      if (error instanceof ValidationException || error instanceof LoginException) {
        throw error;
      }

      logError(error);
      throw error;
    }
  };
}

function blocWrapper(fn, isAsync) {
  if (isAsync) {
    return async function wrap(...args) {
      try {
        return await fn.apply(this, args);
      } catch (error) {
        if (error instanceof LoginException || error instanceof ValidationException) {
          throw error;
        }
        if (!(error instanceof AuthException)) {
          if (!error.logged) {
            const errorRepository = container.resolve('errorRepository');
            errorRepository.error$.next({ message: error.message, severity: 'error' });
            error.logged = true;
          }
          throw error;
        }

        return null;
      }
    };
  }
  return function wrap(...args) {
    try {
      return fn.apply(this, args);
    } catch (error) {
      if (error instanceof LoginException || error instanceof ValidationException) {
        throw error;
      }
      if (!(error instanceof AuthException)) {
        logError(error);
        throw error;
      }
      return null;
    }
  };
}

export function blocErrorHandler(klass) {
  const { prototype } = klass;
  if (Object.getOwnPropertyNames(prototype).length >= 2) {
    Object.keys(Object.getOwnPropertyDescriptors(prototype)).forEach((key) => {
      // wrapping this in a try as trying to wrap getter functions would result in an error, catch is empty since we don't want to wrap them anyways
      try {
        if (key !== 'constructor' && typeof prototype[key] === 'function') {
          const isAsync = prototype[key].constructor.name === 'AsyncFunction';
          prototype[key] = blocWrapper(prototype[key], isAsync);
        }
      } catch (error) {
        //
      }
    });
  }

  return klass;
}

export default (klass) => {
  const { prototype } = klass;

  if (Object.getOwnPropertyNames(prototype).length >= 2) {
    Object.keys(Object.getOwnPropertyDescriptors(prototype)).forEach((key) => {
      if (key !== 'constructor' && typeof prototype[key] === 'function') {
        const isAsync = prototype[key].constructor.name === 'AsyncFunction';
        prototype[key] = safeWrap(prototype[key], isAsync);
      }
    });
  }

  return klass;
};
